import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const fetchTdsTransactionActionable = createAsyncThunk(
  "tdsTransactionApproval/fetchActionable",
  async (values = {}, { rejectWithValue }) => {
    const { sort_by, entityId, page_no, page_size, labels } = values;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/tds/actionable`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            sort_by: sort_by,
            entity_id: entityId,
            labels: labels,
            page_no: page_no,
            page_size: page_size,
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error;

      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const approveTdsTransaction = createAsyncThunk(
  "tdsTransactionApproval/approve",
  async (id, { rejectWithValue }) => {
    try {
      const values = {
        txn_id: Array.isArray(id) ? id : [id],
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/tds/approve`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error;

      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const rejectTdsTransaction = createAsyncThunk(
  "tdsTransactionApproval/reject",
  async ({ id, accountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        txn_id: id,
        reason: accountIdData,
      };

      if (Array.isArray(id)) {
        data.txn_id = id;
      } else {
        data.txn_id = [id];
      }
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/tds/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error;

      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

const tdsTransactionApprovalSlice = createSlice({
  name: "tdsTransactionApproval",

  initialState: {
    tdsTransactionActionableData: null,
    tdsTransactionActionableLoading: false,
    tdsTransactionActionableError: null,

    tdsTransactionApproveData: null,
    tdsTransactionApproveLoading: false,
    tdsTransactionApproveError: null,

    tdsTransactionRejectData: null,
    tdsTransactionRejectLoading: false,
    tdsTransactionRejectError: null,
  },

  reducers: {
    resetTaxMultiApprovalError: (state) => {
      state.tdsTransactionApproveError = false;
    },
    resetTaxDeniedApprovalData: (state) => {
      state.tdsTransactionRejectError = false;
    },
    resetTdsTransactionApproval(state) {
      state.tdsTransactionActionableData = null;
      state.tdsTransactionApproveData = null;
      state.tdsTransactionRejectData = null;

      state.tdsTransactionActionableError = null;
      state.tdsTransactionApproveError = null;
      state.tdsTransactionRejectError = null;

      state.tdsTransactionActionableLoading = false;
      state.tdsTransactionApproveLoading = false;
      state.tdsTransactionRejectLoading = false;
    },
    taxTxnMultiTxnErrors: (state) => {
      state.tdsTransactionApproveData = null;
      state.tdsTransactionApproveError = null;
      state.tdsTransactionRejectData = null;
      state.tdsTransactionRejectError = null;
      state.tdsTransactionRejectLoading = false;
      state.ReimbursementMultiTxnDashBoardLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTdsTransactionActionable.pending, (state) => {
        state.tdsTransactionActionableLoading = true;
        state.tdsTransactionActionableError = null;
        state.tdsTransactionActionableData = null;
      })
      .addCase(fetchTdsTransactionActionable.fulfilled, (state, action) => {
        state.tdsTransactionActionableLoading = false;
        state.tdsTransactionActionableData = action.payload;
      })
      .addCase(fetchTdsTransactionActionable.rejected, (state, action) => {
        state.tdsTransactionActionableLoading = false;
        state.tdsTransactionActionableError = action.payload;
      })
      .addCase(approveTdsTransaction.pending, (state) => {
        state.tdsTransactionApproveLoading = true;
        state.tdsTransactionApproveError = null;
        state.tdsTransactionApproveData = null;
      })
      .addCase(approveTdsTransaction.fulfilled, (state, action) => {
        state.tdsTransactionApproveLoading = false;
        state.tdsTransactionApproveData = action.payload;
      })
      .addCase(approveTdsTransaction.rejected, (state, action) => {
        state.tdsTransactionApproveLoading = false;
        state.tdsTransactionApproveError = action.payload;
        if (action?.payload?.response?.data?.errors?.base || action.payload) {
          sessionStorage.setItem(
            "taxTxnDataError",
            JSON.stringify(
              action?.payload?.response?.data?.errors?.base || action.payload,
            ),
          );
        }
      })
      .addCase(rejectTdsTransaction.pending, (state) => {
        state.tdsTransactionRejectLoading = true;
        state.tdsTransactionRejectError = null;
        state.tdsTransactionRejectData = null;
      })
      .addCase(rejectTdsTransaction.fulfilled, (state, action) => {
        state.tdsTransactionRejectLoading = false;
        state.tdsTransactionRejectData = action.payload;
      })
      .addCase(rejectTdsTransaction.rejected, (state, action) => {
        if (action.payload?.errors?.base) {
          sessionStorage.setItem(
            "taxTxnDataError",
            JSON.stringify(action.payload.errors.base),
          );
        } else if (action.payload) {
          sessionStorage.setItem(
            "taxTxnDataError",
            JSON.stringify(action.payload),
          );
        }
        state.tdsTransactionRejectLoading = false;
        state.tdsTransactionRejectError = action.payload;
      });
  },
});

export const {
  resetTdsTransactionApproval,
  resetTaxMultiApprovalError,
  resetTaxDeniedApprovalData,
  taxTxnMultiTxnErrors,
} = tdsTransactionApprovalSlice.actions;

export default tdsTransactionApprovalSlice.reducer;
